<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/7/logo.png`" :width="1.31" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/7/banner.jpg`" />
			<cloud />
		</div>
		<div class="brandWrap brand7" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn'}">
				<p :class="{'field_1 item_center': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_1"></p>
				<p :class="{'field_2 item_center': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.71rem' : '0.6rem' }" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.58rem' : '1.125rem' }"><img :src="detail.field_3" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.38rem' : '1.725rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_4"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.69rem' : '0.62rem' }" v-html="detail.field_5"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.1rem' : '0.425rem' }"><img :src="detail.field_6" width="100%" /></p>
			<div class="brandWrapModule" style="padding-left:0.04rem" :style="{ 'marginTop': lang=='zh-cn'? '1.33rem' : '1.475rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_7"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" style="margin-top: 0.7rem; width:5.74rem" v-html="detail.field_8"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.03rem' : '0.775rem' }"><img :src="detail.field_9" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.26rem' : '1.525rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_10"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.76rem' : '0.62rem' }" v-html="detail.field_11"></p>
			</div>
			<div class="pressImgWrap" style="margin-top:3rem">
				<img :src="detail.field_13" width="100%" />
				<img class="bottomImg" :src="detail.field_12" width="100%" />
			</div>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.27rem' : '1.36rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_14"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.66rem' : '0.62rem' }" v-html="detail.field_15"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.43rem' : '1.43rem' }"><img :src="detail.field_16" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.21rem' : '1.425rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_17"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.67rem' : '0.62rem' }" v-html="detail.field_18"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '0.79rem' : '1.155rem' }"><img :src="detail.field_19" width="100%" /></p>
			<a class="brandLinkWrap pink" href="https://www.yeehoo.com.cn" target="_blank">
				<p class="brandLink1">{{ $t('shoplink') }}</p>
				<p class="brandLink2">www.yeehoo.com.cn</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(14)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand7.vue